(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["wh-faq-schema"] && !Shopify.designMode) return;
  try {
    
// Vanilla JS replacement for the PXU-dependent original (ported to BBS 2026-05-28)
(function() {
  function updateHeights(root) {
    var ctx = root || document;
    ctx.querySelectorAll('.wh-faq-schema [data-wh-faq-answer]').forEach(function(ans) {
      ans.style.setProperty('--open-height', ans.scrollHeight + 'px');
    });
  }

  function init() {
    updateHeights();
    document.querySelectorAll('.wh-faq-schema [data-wh-faq-item]').forEach(function(d) {
      d.addEventListener('toggle', function() { updateHeights(); });
    });
    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() { updateHeights(); }, 200);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
